// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2IXP6","consentsList":"PatientConsents_consentsList__3yoP8","consentsListEmpty":"PatientConsents_consentsListEmpty__HWcO_"};